var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.98.919C14.677.693 7.32.694 4.02.919.447 1.163.027 3.32 0 9c.027 5.67.444 7.837 4.02 8.081 3.3.225 10.657.226 13.96 0 3.573-.243 3.993-2.401 4.02-8.08-.027-5.67-.444-7.837-4.02-8.082ZM8.25 12.667V5.333l7.333 3.66-7.333 3.674Z",
    fill: "#000"
  })));
};

export default SvgYoutubeIcon;